export default "__VITE_ASSET__BKl6hdQ___"